import { render, staticRenderFns } from "./ArvoreItem.vue?vue&type=template&id=fbb7ca80"
import script from "./ArvoreItem.vue?vue&type=script&lang=js"
export * from "./ArvoreItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports